import { getSnappedMousePosition } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/actions/utils/getSnappedMousePosition';
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import {
  Belegung,
  BelegungsIntervall,
} from '@/domain/dienstplan/shared/types/Belegung';
import { Point } from 'recharts/types/shape/Curve';

export function startBelegungRightResize({
  ctx,
  currentPoint,
  currentBelegung,
}: {
  currentPoint: Point;
  currentBelegung: BelegungsIntervall;
  ctx: SharedContext;
}) {
  const {
    store: { updateBelegungById, setStartBelegungPosition, setIsResizingEnde },
  } = ctx;

  const { x, y } = getSnappedMousePosition(ctx, currentPoint);

  const newBelegung = new Belegung({
    ...currentBelegung.belegung,
    ende: x,
  });

  updateBelegungById(
    new BelegungsIntervall(newBelegung, 'resize'),
    newBelegung.id,
  );
  setStartBelegungPosition({ x, y });
  setIsResizingEnde(true);
}
